import { render, staticRenderFns } from "./KText.vue?vue&type=template&id=11c98719"
import script from "./KText.vue?vue&type=script&lang=js"
export * from "./KText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports